export { LoyaltyPassController as LoyaltyPassModal, useLoyaltyPassModal } from './loyalty-pass-controller';
